import { Tooltip } from '@mui/material';

import { IFCWithChildren } from '~/common/interfaces/IFCWithChildren';
import { IAboveComponentDefaultProps } from '~/common/interfaces/IAboveComponentDefaultProps';

interface ISimpleTooltipProps extends IAboveComponentDefaultProps {
  message: string;
  background?: 'neutral.50' | 'neutral.950';
}

export const SimpleTooltip: IFCWithChildren<ISimpleTooltipProps> = ({
  message,
  children,
}) => {
  return (
    <Tooltip title={message} arrow>
      <div>{children}</div>
    </Tooltip>
  );
};
